<template>
  <modal-card
    title="Confirm Contact Info"
    fixed
    padding
    :loading="loading"
    @close="$emit('close')"
  >
    <v-form v-model="isFormValid" @submit.prevent>
      <v-row class="mt-0">
        <v-col cols="6">
          <v-text-field
            v-model="form.first_name"
            label="First Name"
            dense
            :rules="requiredRules('First Name')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="form.last_name"
            label="Last Name"
            dense
            :rules="requiredRules('Last Name')"
          />
        </v-col>
      </v-row>

      <v-text-field
        v-model="form.email"
        label="Email"
        class="mt-3"
        dense
        :rules="emailRules"
      />

      <v-text-field
        v-model="form.zip_code"
        label="Zip Code"
        class="mt-3"
        dense
        :rules="requiredRules('Zip Code')"
      />

      <v-select
        v-model="form.gender"
        label="Gender"
        class="mt-3"
        :items="genderOptions"
        clearable
      />

      <v-select
        v-model="form.age_bracket"
        label="Age Bracket"
        class="mt-3"
        :items="ageBracketOptions"
        clearable
      />
    </v-form>

    <template #actions>
      <v-btn
        color="appMain"
        :disabled="!isFormValid || loading"
        @click="confirm"
      >
        Continue
      </v-btn>
    </template>
  </modal-card>
</template>

<script>
import { mapGetters } from 'vuex';
import validationRules from '@/lib/validationRules';
import { RECRUITING_STATUS } from '../../recruitingConstants';

const FIELDS = [
  'first_name',
  'last_name',
  'email',
  'zip_code',
  'gender',
  'age_bracket',
];

export default {
  name: 'ContactInfoConfirmation',
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    contactId: String,
    loading: Boolean,
  },
  data() {
    return {
      isFormValid: false,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        zip_code: '',
        gender: '',
        age_bracket: '',
      },
      genderOptions: ['male', 'female', 'unknown'],
      ageBracketOptions: ['18 or older', '17 & HS grad', 'unqualified age'],
    };
  },
  computed: {
    ...mapGetters('fields', ['getSingleField']),
    emailRules() {
      return [
        (v) => validationRules.checkRequired(v, 'Email'),
        (v) => validationRules.checkEmail(v) || 'Email must be valid',
      ];
    },
  },
  watch: {
    contact: {
      immediate: true,
      handler(val) {
        if (!val) return;
        FIELDS.forEach((key) => {
          this.form[key] = val[key] || '';
        });
      },
    },
  },
  methods: {
    requiredRules(fieldName) {
      return [(v) => validationRules.checkRequired(v, fieldName)];
    },

    confirm() {
      if (!this.isFormValid) return;
      this.$emit('confirm', {
        zip_code: this.form.zip_code,
        contactParams: this.buildContactParams(),
      });
    },

    buildContactParams() {
      const params = {};

      const setFieldValue = (field, value) => {
        const schema = this.getSingleField(field);
        if (!schema) return;

        params[schema.bucketId] ||= {};
        params[schema.bucketId][schema.name] = value;
      };

      FIELDS.forEach((field) => {
        const currentValue = this.contact?.[field] || '';
        const newValue = this.form[field];

        if (newValue !== currentValue) {
          setFieldValue(field, newValue);
        }
      });

      if (this.contact?.status !== RECRUITING_STATUS.REACHED) {
        setFieldValue('status', RECRUITING_STATUS.REACHED);
      }

      return params;
    },
  },
};
</script>
